export default "__VITE_ASSET__CxSDT1uh__"